import { Component, Inject, Injector, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AppComponentBase } from '@shared/app-component-base';
import { UserCustomerDto, UserServiceProxy } from '@shared/service-proxies/service-proxies';
import { CustomLocalizationService } from '../../utility/customLocalization.service';
import { AppConsts } from '@shared/AppConsts';
import { LoginService } from 'test/service/login.service';

@Component({
  selector: 'kt-change-usercustomer-modal',
  templateUrl: './change-usercustomer-modal.component.html',
  styleUrls: ['./change-usercustomer-modal.component.scss']
})
export class ChangeUsercustomerModalComponent extends AppComponentBase implements OnInit {

  selectUserCustomer: UserCustomerDto;

  selectPassword: string;
  constructor(
	  injector: Injector,
	  private _userService: UserServiceProxy,
	  private _loginService: LoginService,
	  public dialogRef: MatDialogRef<ChangeUsercustomerModalComponent>,
    @Inject(MAT_DIALOG_DATA) 
	  public _data: any,
	  private customLocalization: CustomLocalizationService
  ) {

    super(injector);

   }

	currentUserCustomer: UserCustomerDto;
	ngOnInit() {
		this.currentUserCustomer = this._data.selectCustomer;

    this.selectUserCustomer = this._data.selectCustomer;

  }

  onClickChangeDefaultTitle(){

    //if(this.selectPassword.length < 4){
    //  this.uiMessage.modal.error("","En az 4 karakter girmelisiniz.",null);
    //  return;
    //}
	  if (this.selectPassword.trim().length < 1) {
		  this.uiMessage.modal.error("", this.customLocalization.l("FE.REQUIREDFIELDS.COMMON.PASSWORD"), null);
			return;

	 }

   var currentUserId = this.appSession.user.id;

   abp.auth.clearToken();
   abp.utils.setCookieValue(AppConsts.authorization.encryptedAuthTokenName, undefined, undefined, abp.appPath);

	  this._userService.changeUserCustomer(currentUserId, this.selectPassword, this.currentUserCustomer.id)
		  .subscribe(result => {
			  
        this._loginService.loginToServer(this.appSession.user.userName, this.selectPassword);
            


			  // this._userService.customLogin(this.selectPassword)
				//   .subscribe(result => {

				// 	  this.dialogRef.close(true);

				//   })
			  
	  })
	 
    //alert(this.selectPassword);
    //İşlem yapılacak method

  }

}
